module.exports = __webpack_public_path__ + "img/chevron-downx2.804ef592.svg";